import { IProgressBarVariants, PROGRESSBAR_VARIANTS } from './types';

export const variants: IProgressBarVariants = {
  [PROGRESSBAR_VARIANTS.PRIMARY]: {
    container: {
      border: '1px solid  var(--clr-tertiary-1)',
    },
    bar: {
      border: 'none',
      backgroundColor: 'var(--clr-tertiary-1)',
      color: 'var(--white)',
    },
    background: {
      border: 'none',
      backgroundColor: 'var(--clr-tertiary-2)',
      color: 'var(--black)',
    },
  },

  [PROGRESSBAR_VARIANTS.LIGHT]: {
    container: {
      border: '1px solid #FFF',
    },
    bar: {
      border: '1px solid rgba(0, 0, 0, 0.3)',
      backgroundColor: 'var(--white)',
      color: 'var(--black)',
    },
    background: {
      border: '1px solid #e0dbd5',
      backgroundColor: '#e0dbd5',
      color: 'var(--black)',
    },
  },

  [PROGRESSBAR_VARIANTS.DARK]: {
    container: {
      border: '1px solid var(--clr-tertiary-2)',
    },
    bar: {
      border: 'none',
      backgroundColor: 'var(--clr-tertiary-2)',
      color: 'var(--black)',
    },
    background: {
      border: 'none',
      backgroundColor: '#e0dbd5',
      color: 'var(--black)',
    },
  },
};
